import { createContext, useContext } from "react";
import type { StaticTracking } from "./useStaticTracking";

/**
 * The Tracking step's form, owned by the builder mount (above the shell) so it
 * survives step switches. The step consumes this rather than holding the state,
 * which would be lost when it unmounts on leaving the step.
 */
export const TrackingContext = createContext<StaticTracking | null>(null);

export const useTracking = (): StaticTracking => {
  const ctx = useContext(TrackingContext);
  if (!ctx) throw new Error("useTracking must be used within a TrackingContext provider");
  return ctx;
};
